module.exports = __webpack_public_path__ + "static/media/Sheldon_Jordan.08300326.png";